export enum RenalDetectStatusEnum {
  NotAtRisk = 'notAtRisk',
  AtRisk = 'atRisk',
  CKD = 'sick',
}
